import React from "react";
import ReactSelect from "react-select";
import { Option, customStyles } from "../../../financial-target-wizard/controlled-select";
import "./select.css";

export type Option = {
    value: string;
    label: string;
};

export type GroupedOption = {
    label: string;
    options: Option[];
};

interface Props {
    options: GroupedOption[];
    value: Option;
    defaultValue: Option;
    onChange: (option: { value: string }) => void;
    placeholder?: string;
    id?: string;
}

export const Select = ({ options, value, onChange, defaultValue, placeholder, id }: Props) => {
    return (
        <ReactSelect
            value={value}
            defaultValue={defaultValue}
            onChange={onChange}
            options={options}
            formatGroupLabel={formatGroupLabel}
            menuPosition="fixed"
            components={{ Option }}
            styles={styles}
            placeholder={placeholder}
            id={id}
        />
    );
};

const styles = {
    ...customStyles,
    groupHeading: (provided) => ({
        ...provided,
        padding: 0,
        fontSize: "12px",
        color: "#585858",
        textTransform: "capitalize",
    }),
};

const formatGroupLabel = (data: GroupedOption) => {
    return (
        <div>
            {/* <div className="select-category-divider" /> */}
            <span className="select-group-label">{data.label}</span>
        </div>
    );
};
